export const careBalanceLearnMoreUrl = process.env.REACT_APP_CARE_BALANCE_LEARN_MORE_URL